const tosContainer = document.querySelector('div.cart__tos');
const tosCheckbox = document.querySelector('div.cart__tos input[type="checkbox"]');
const checkoutButton = document.querySelector('button#checkout');

const hasSubscriptionItems = (items) => {
  subscriptionItems = $.grep(items, (item) => item.hasOwnProperty('selling_plan_allocation'));

  return subscriptionItems.length > 0;
}

const hideTermsOfService = () => {
  checkoutButton.setAttribute('disabled', 'disabled');
  tosContainer.style.display = 'none';
  tosContainer.checked = false;
}

const checkTermsOfService = () => {
  fetch('/cart.json')
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((cart) => {
      if (hasSubscriptionItems(cart.items)) {
        tosContainer.style.display = 'block';
      } else {
        checkoutButton.removeAttribute('disabled');
      }
    });
}

window.addEventListener('CartItems:updateQuantityStart', () => {
  hideTermsOfService();
});

window.addEventListener('CartItems:updateQuantityEnd', () => {
  hideTermsOfService();
  checkTermsOfService();
});

tosCheckbox.addEventListener('change', () => {
  if (tosCheckbox.checked) {
    checkoutButton.removeAttribute('disabled');
  } else {
    checkoutButton.setAttribute('disabled', 'disabled');
  }
});

(() => {
  hideTermsOfService();
  checkTermsOfService();
})();